// extracted by mini-css-extract-plugin
export default {"container":"Resources_container__PycBJ","sidebar":"Resources_sidebar__bNxOd","mainContent":"Resources_mainContent__kkhZJ","bold":"Resources_bold__er1kC"};